/**
 * Validadores de documentos e campos brasileiros (CPF, CNPJ, CEP, e-mail).
 */

export const onlyDigits = (value?: string | null): string => (value || '').replace(/\D/g, '');

const allSameDigits = (digits: string): boolean => /^(\d)\1*$/.test(digits);

export const isValidCPF = (value?: string | null): boolean => {
    const cpf = onlyDigits(value);
    if (cpf.length !== 11 || allSameDigits(cpf)) return false;

    const calcDigit = (base: string, startWeight: number): number => {
        let sum = 0;
        for (let i = 0; i < base.length; i++) {
            sum += Number(base[i]) * (startWeight - i);
        }
        const rest = (sum * 10) % 11;
        return rest === 10 ? 0 : rest;
    };

    const d1 = calcDigit(cpf.substring(0, 9), 10);
    const d2 = calcDigit(cpf.substring(0, 10), 11);
    return d1 === Number(cpf[9]) && d2 === Number(cpf[10]);
};

export const isValidCNPJ = (value?: string | null): boolean => {
    const cnpj = onlyDigits(value);
    if (cnpj.length !== 14 || allSameDigits(cnpj)) return false;

    const calcDigit = (base: string): number => {
        const weights = base.length === 12
            ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
            : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
        let sum = 0;
        for (let i = 0; i < base.length; i++) {
            sum += Number(base[i]) * weights[i];
        }
        const rest = sum % 11;
        return rest < 2 ? 0 : 11 - rest;
    };

    const d1 = calcDigit(cnpj.substring(0, 12));
    const d2 = calcDigit(cnpj.substring(0, 13));
    return d1 === Number(cnpj[12]) && d2 === Number(cnpj[13]);
};

export const isValidCEP = (value?: string | null): boolean => onlyDigits(value).length === 8;

export const isValidEmail = (value?: string | null): boolean =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((value || '').trim());
